import {environment} from "../../environments/environment";
import {TipoProgetto} from "../../environments/BaseEnvironments/Model";

export function CalcIva(prezzo: number, iva: number){
  return (prezzo /100) *  iva;
}
export function getSettings(tipo: string):TipoProgetto {
  return environment.ProgettiAddon['TipiProgetto']?.find(x => x.id == tipo) ?? {
    nome: 'Offerte',
    id: "T",
    colore: "#1baa03",
    restRoute: "/progetti/progetti",
    capacita: [],
    HideVoci:false
  };
}
export function RestRoute(tipo: string) : string {
  return getSettings(tipo).restRoute ?? "/progetti/progetti";
}
